import * as React from "react";

export const PaycurraBg: React.FC<any> = ({ children }) => {
  return (
    <section className="min-h-[calc(100vh-275px)] w-full ladybug_bg_w">{children}</section>
  );
};
